import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../lib/auth';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success('Bem-vindo de volta!');
      navigate('/');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Falha no login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--app-bg)] grid lg:grid-cols-2">
      <div className="hidden lg:flex relative items-center justify-center p-12 overflow-hidden" style={{
        background: 'radial-gradient(1200px circle at 10% 0%, rgba(122,167,255,0.18), transparent 55%), radial-gradient(900px circle at 90% 90%, rgba(31,122,90,0.10), transparent 50%), linear-gradient(180deg, #F7F8FA 0%, #EEF1F6 100%)',
      }}>
        <div className="relative z-10 max-w-md">
          <div className="flex items-center gap-2 mb-8">
            <div className="h-10 w-10 rounded-xl bg-[hsl(var(--primary))] grid place-items-center text-white font-heading font-bold text-lg">A</div>
            <div className="font-heading font-semibold text-lg">AutoSócios</div>
          </div>
          <h2 className="font-heading text-4xl font-semibold tracking-tight mb-3">Gestão de investimentos por veículo.</h2>
          <p className="text-base text-muted-foreground leading-relaxed">
            Controle compra, despesas, venda e a distribuição de resultados entre sócios com clareza profissional.
          </p>
          <div className="mt-10 grid grid-cols-2 gap-4">
            <div className="rounded-xl border border-border/70 bg-card/80 backdrop-blur p-4">
              <div className="text-xs text-muted-foreground">Lucro líquido</div>
              <div className="mt-1 text-xl font-semibold tabular text-[hsl(var(--success))]">+R$ 22.000,00</div>
            </div>
            <div className="rounded-xl border border-border/70 bg-card/80 backdrop-blur p-4">
              <div className="text-xs text-muted-foreground">ROI médio</div>
              <div className="mt-1 text-xl font-semibold tabular">8,37%</div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12">
        <Card className="w-full max-w-md border-border/70">
          <CardContent className="p-6 lg:p-8">
            <div className="lg:hidden flex items-center gap-2 mb-6">
              <div className="h-9 w-9 rounded-lg bg-[hsl(var(--primary))] grid place-items-center text-white font-heading font-bold">A</div>
              <div className="font-heading font-semibold">AutoSócios</div>
            </div>
            <h1 className="font-heading text-2xl font-semibold tracking-tight">Entrar na conta</h1>
            <p className="mt-1 text-sm text-muted-foreground">Acesse o painel da sua empresa.</p>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
              <div>
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
              </div>
              <div>
                <Label htmlFor="password">Senha</Label>
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
              </div>
              <Button type="submit" className="w-full bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90" disabled={loading} data-testid="login-submit-button">
                {loading ? 'Entrando...' : 'Entrar'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
